const API_URL = process.env.REACT_APP_API_URL;
const API_KEY = process.env.REACT_APP_API_KEY;
class ApiService {
  async fetch(endpoint, options = {}) {
    const token = localStorage.getItem('token');
    
    const defaultHeaders = {
      'Content-Type': 'application/json',
      'X-API-Key': API_KEY,
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    };
    

    const response = await fetch(`${API_URL}${endpoint}`, {
      ...options,
      headers: {
        ...defaultHeaders,
        ...options.headers,
      },
    });

    if (response.status === 401) {
      // Token expiré ou invalide
      localStorage.removeItem('token');
      window.location.href = '/login';
      throw new Error('Session expirée');
    }

    const data = await response.json();

    if (!response.ok) {
      // Créer une erreur personnalisée qui préserve les données de validation
      const error = new Error(data.message || 'Une erreur est survenue');
      error.response = {
        status: response.status,
        data: data
      };
      error.validationErrors = data.data || [];
      throw error;
    }

    return data;
  }

  get(endpoint) {
    return this.fetch(endpoint);
  }

  post(endpoint, body) {
    return this.fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  put(endpoint, body) {
    return this.fetch(endpoint, {
      method: 'PUT',
      body: JSON.stringify(body),
    });
  }

  delete(endpoint, body) {
    return this.fetch(endpoint, {
      method: 'DELETE',
      body: JSON.stringify(body),
    });
  }

  async fetchBlob(endpoint) {
    const token = localStorage.getItem('token');
    const defaultHeaders = {
      'X-API-Key': API_KEY,
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    };
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'GET',
      headers: defaultHeaders,
    });
    if (response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
      throw new Error('Session expirée');
    }
    if (!response.ok) {
      const text = await response.text();
      let message = 'Une erreur est survenue';
      try {
        const data = JSON.parse(text);
        message = data.message || message;
      } catch (_) {}
      throw new Error(message);
    }
    return response.blob();
  }

  async postFormData(endpoint, formData) {
    const token = localStorage.getItem('token');
    
    const headers = {
      'X-API-Key': API_KEY,
      ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    };

    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers: headers,
      body: formData
    });

    if (response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
      throw new Error('Session expirée');
    }

    const data = await response.json();

    if (!response.ok) {
      // Créer une erreur personnalisée qui préserve les données de validation
      const error = new Error(data.message || 'Une erreur est survenue');
      error.response = {
        status: response.status,
        data: data
      };
      error.validationErrors = data.data || [];
      throw error;
    }

    return data;
  }

  async downloadFile(endpoint, filename) {
    const token = localStorage.getItem('token');
    
    const headers = {
      'X-API-Key': API_KEY,
      ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    };

    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'GET',
      headers: headers,
    });

    if (response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
      throw new Error('Session expirée');
    }

    if (!response.ok) {
      const errorText = await response.text();
      let errorData;
      try {
        errorData = JSON.parse(errorText);
      } catch (e) {
        errorData = { message: 'Une erreur est survenue lors du téléchargement' };
      }
      throw new Error(errorData.message || 'Une erreur est survenue lors du téléchargement');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || 'download';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}

export default new ApiService(); 